import MultilangText from '@data/models/MultilangText';
/**
 * As of now, custom payment option is only configurable by custom JS.
 * We support only one and when this is set in the environment,
 * the data shown in the bank transfer option is replaced with this data.
 *
 * It is mandatory that the property has bank transfer enabled in order to use a custom payment option.
 *
 * Plain (non-observable) on purpose: its fields are set once in the constructor
 * and never mutated, so it needs no mobx — keeping it out of the payment popup
 * bundle (BENG-4169). Reactivity, when needed, comes from the store field that
 * holds it being reassigned wholesale.
 */
export default class CustomPaymentOption {
    constructor({ id, instructions, name }) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "instructions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = id;
        this.instructions = instructions
            ? new MultilangText(instructions)
            : undefined;
        this.name = new MultilangText(name);
    }
}
